import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from '../images/logotext.png';
import '../css/sidebar.css';

function Sidebar({ hideSidebar }) {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();
  
  const name = localStorage.getItem("client");
  const username = localStorage.getItem("username");
  const isAdmin = username === "admin" || username === "superadmin";
  const showPhenological = name === "padornelo" || name === "padornelo";
  const isSuperadmin = username === "superadmin";
  // Menú con control de visibilidad
  const menuItems = [
    {
      id: 'pollination',
      title: 'Polinización',
      icon: 'bi bi-clipboard-data',
      visible: true,
      items: [
        { path: '/', title: 'Cantidades', icon: 'bi-pie-chart-fill' },
        { path: '/dashboard-average', title: 'Promedios', icon: 'bi-bar-chart-line' },
        { path: '/first-applications', title: 'Aplicaciones por tipo', icon: 'bi-flower3' },
        { path: '/first-applications-month', title: 'Aplicaciones por tipo Mes', icon: 'bi-flower3' },
        { path: '/operating-performance', title: 'Rendimiento operativo', icon: 'bi-bar-chart-steps' },
        { path: '/operating-indicators', title: 'Indicadores operativos', icon: 'bi-bar-chart-steps' },
        { path: '/productivity', title: 'Tasa de floración', icon: 'bi-flower3' },
        { path: '/performance', title: 'Desempeño horario', icon: 'bi-bar-chart-line' },
        { path: '/projection', title: 'Proyección', icon: 'fa-solid fa-chart-line' },
        { path: '/cycles', title: 'Ciclos de polinización', icon: 'fa-solid fa-arrows-spin' },
        { path: '/comparative-cycles', title: 'Seguimiento de Ciclos', icon: 'fa-solid fa-eye'},
        { path: '/yearly-comparison', title: 'Comparativo anual', icon: 'bi-calendar' }
      ]
    },
    {
      id: 'reports',
      title: 'Informes polinización',
      icon: 'bi bi-file-earmark-spreadsheet',
      visible: true,
      items: [
        { path: '/report-movements', title: 'Acumulado labor', icon: 'fa-solid fa-list' },
        { path: '/report-operator-lot', title: 'Operador lote', icon: 'fa-solid fa-list' },
        { path: '/accumulation-by-lot', title: 'Acumulado por lote', icon: 'fa-solid fa-list' },
        { path: '/accumulation-by-month', title: 'Acumulado mensual', icon: 'fa-solid fa-list' },
        { path: '/accumulation-by-month-lot', title: 'Acumulado lote/mes', icon: 'fa-solid fa-list'},
        { path: '/report-consumption', title: 'Consumos', icon: 'fa-solid fa-list' },
        { path: '/report-payment', title: 'Pago por labor', icon: 'fa-solid fa-list' },
        { path: '/report-duplicate', title: 'Duplicados', icon: 'fa-solid fa-list' },        
        { path: '/pollination-detailed-report', title: 'Polinización Detallado', icon: 'fa-solid fa-list' },
      ]
    },
    {
      id: 'harvest',
      title: 'Cosecha',
      icon: 'bi-folder',
      visible: true,
      items: [
        { path: '/yield', title: 'Cantidades', icon: 'bi-pie-chart-fill' },
        { path: '/yield-operator-lot-report', title: 'Operador lote', icon: 'fa-solid fa-list' },
        { path: '/yield-detailed-report', title: 'Reporte detallado', icon: 'fa-solid fa-list' },
      ]
    },
    {
      id: 'health',
      title: 'Sanidad',
      icon: 'bi-folder',
      visible: true, // 👈 oculto
      items: [
        { path: '/admin-health-issues', title: 'Problemas de sanidad', icon: 'bi-bug-fill' },
        { path: '/health-detailed', title: 'Informe detallado', icon: 'fa-solid fa-list' },
        { path: '/health-movements-map', title: 'Mapa de novedades', icon: 'fa-solid fa-map' },
        { path: '/health-treatment-map', title: 'Mapa de tratamientos', icon: 'fa bi-map' },
        { path: '/health-trap-map', title: 'Registro de trampas', icon: 'fa bi-box' , badge: 'NEW' }
      ]
    },//
    {
      id: 'irrigation',
      title: 'Gestión hídrica',
      icon: 'bi-folder',
      visible: isSuperadmin, // 👈 oculto
      items: [
        { path: '/insert-rainfall', title: 'Lluvias', icon: 'bi-cloud-rain' },
        { path: '/rainfall-production', title: 'Lluvias vs producción', icon: 'fa-solid fa-chart-line' },
      ]
    },//
    {
      id: 'phenological',
      title: 'Feonologia',
      icon: 'bi-flower3',
      visible: showPhenological, // 👈 oculto
      items: [
        { path: '/phenological-dashboard', title: 'Fenología', icon: 'bi-flower3' },
        { path: '/phenological-report', title: 'Fenología', icon: 'fa-solid fa-list'}
      ]
    },//
    {
      id: 'maps',
      title: 'Mapas',
      icon: 'bi-map',
      visible: true,
      items: [
        { path: '/track-mapbox', title: 'Tracking', icon: 'bi-pin-map-fill' },
        { path: '/non-productive-plants', title: 'Improductividad', icon: 'bi-pin-map' },
        { path: '/fruit-inventory', title: 'Inventario de fruta', icon: 'bi-flower3' },
        { path: '/map-first-application', title: 'Flores 1ra por mes', icon: 'bi-flower3' },
        { path: '/map-first-application-range', title: 'Flores 1ra acumulado', icon: 'bi-flower3' },
        //{ path: '/heat-map-first-application', title: 'Flores primera zonas', icon: 'bi-flower3' },
        { path: '/cycle-compliance', title: 'Cumplimiento de ciclos', icon: 'fa-solid fa-arrows-spin', badge: 'NEW' },
        { path: '/polygon-hectare-lot', title: 'Produccion por ha', icon: 'bi bi-pentagon-half', badge: 'NEW' }
      ]
    },
    {
      id: 'supervision',
      title: 'Supervisión',
      icon: 'bi-card-checklist',
      visible: true,
      items: [
        { path: '/supervision-quality', title: 'Análisis calidad', icon: 'fa-solid fa-list' },
        { path: '/supervision-reliability', title: 'Análisis confiabilidad', icon: 'fa-solid fa-list' },
        { path: '/supervision-metrics', title: 'Análisis acumulado', icon: 'fa-solid fa-list' },
        { path: '/supervision-report', title: 'Datos supervisión', icon: 'fa-solid fa-list' }
      ]
    },
    {
      id: 'records',
      title: 'Registros',
      icon: 'bi-card-checklist',
      visible: true,
      items: [
        { path: '/upload-movements', title: 'Subir movimientos', icon: 'bi-upload' },
        { path: '/update-record', title: 'Corregir movimientos', icon: 'fa-solid fa-list' },
        { path: '/insert-record', title: 'Ingresar movimiento', icon: 'fa-solid fa-list' },
        { path: '/update-supervision', title: 'Corregir supervisión', icon: 'fa-solid fa-list' },
        { path: '/report-accumulation', title: 'Paquetes subidos', icon: 'bi-file-arrow-up' }
      ]
    }
  ];

  const adminItems = [
    { id: 'farms', path: '/admin-farms', title: 'Fincas', icon: 'bi-house-door-fill' },
    { id: 'users', path: '/admin-users', title: 'Usuarios', icon: 'bi-people' }
  ];

  const toggleMenu = (menuId) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  // Auto-abrir menú activo
  React.useEffect(() => {
    const newOpenMenus = {};
    menuItems.forEach(menu => {
      if (menu.visible !== false && menu.items.some(item => item.path === location.pathname)) {
        newOpenMenus[menu.id] = true;
      }
    });
    setOpenMenus(newOpenMenus);
  }, [location.pathname]);

  const logOut = () => {
    localStorage.setItem("isLogin", false);
    localStorage.setItem("token", "NOK");
    window.location.href = '/login';
  };

  return (
    <div className="sidebar-moderno d-flex flex-column">
      {/* Logo */}
      <div className="logo-container">
        <NavLink to="/" className="text-decoration-none">
          <img src={logo} alt="Logo" className="logo" />
        </NavLink>
      </div>

      {/* Menú principal */}
      <div className="flex-grow-1 px-2">
        {menuItems
          .filter(menu => menu.visible !== false)
          .map(menu => (
          <div key={menu.id}>
            <div 
              className="menu-item"
              onClick={() => toggleMenu(menu.id)}
            >
              <i className={`bi ${menu.icon} menu-icon`}></i>
              <span className="fw-medium">{menu.title}</span>
              <i className={`bi bi-chevron-left chevron-icon ${openMenus[menu.id] ? 'rotated' : ''}`}></i>
            </div>

            <div className={`submenu ${openMenus[menu.id] ? 'open' : ''}`}>
              {menu.items.map(item => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => 
                    `submenu-item ${isActive ? 'active' : ''}`
                  }
                  onClick={hideSidebar}
                >
                  <i className={`${item.icon} menu-icon`}></i>
                  <span>{item.title}</span>
                  {item.badge && <span className="badge-new">{item.badge}</span>}
                </NavLink>
              ))}
            </div>
          </div>
        ))}

        {/* Admin */}
        {isAdmin && adminItems.map(item => (
          <NavLink
            key={item.id}
            to={item.path}
            className={({ isActive }) => 
              `menu-item ${isActive ? 'active' : ''}`
            }
            onClick={hideSidebar}
          >
            <i className={`bi ${item.icon} menu-icon`}></i>
            <span className="fw-medium">{item.title}</span>
          </NavLink>
        ))}

        {/* Logout */}
        <div className="menu-item" onClick={logOut}>
          <i className="bi bi-box-arrow-in-left menu-icon"></i>
          <span className="fw-medium">Cerrar sesión</span>
        </div>
      </div>

      {/* Usuario */}
      <div className="user-info">
        <div className="d-flex align-items-center">
          <i className="bi bi-database"></i>
          <span className="text-truncate">{name}</span>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;